import React from 'react'
import BaseIcon from 'react-icon-base'

const SG = props => (
  <BaseIcon width={21} height={15} viewBox="0 0 21 15" {...props}>
    <title>SG</title>
    <defs>
      <rect id="a" width="21" height="15" rx="2" />
      <path
        id="c"
        d="M7.438.5H1.499C.946.5.5.95.5 1.507v11.986c0 .556.455 1.007.992 1.007h18.016c.548 0 .992-.45.992-1.007V1.507C20.5.95 20.055.5 19.499.5H7.438z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <use fill="#FFF" xlinkHref="#a" />
      <path fill="#ED3A40" d="M0 0h21v8H0z" mask="url(#b)" />
      <path fill="#FFF" d="M4 2c.365 0 .707.098 1.001.268A2 2 0 1 0 5 5.732 2 2 0 1 1 4 2z" mask="url(#b)" />
      <path fill="#FFF" d="M7 5v1H6V5h1zm2 0v1H8V5h1zm1-2v1H9V3h1zM6 3v1H5V3h1zm2-1v1H7V2h1z" mask="url(#b)" />
      <use stroke="#2F343A" strokeOpacity=".157" xlinkHref="#c" />
    </g>
  </BaseIcon>
)

export default SG
